import React from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import GenericPopup from "./GenericPopup";

function PopupConfirmation({show, text, onHide, onConfirm, icon}) {

    function getFooter() {
        return (
            <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                <Button variant="secondary" onClick={() => onConfirm(false)}>
                    Zrušiť
                </Button>
                <Button variant="primary" onClick={() => onConfirm(true)}>
                    Potvrdiť
                </Button>
            </div>
        );
    }

    return (
        <GenericPopup show={show} text={text} onHide={onHide} onConfirm={onConfirm} icon={icon} footer={getFooter()}/>
    );
}

export default PopupConfirmation
